/**
 * ProgressBar Component
 *
 * Visual progress indicator for runs
 * Displays percentage with color-coded progress bar
 */

import React from 'react';

interface ProgressBarProps {
  current: number;
  total: number;
  className?: string;
  showLabel?: boolean;
}

export const ProgressBar: React.FC<ProgressBarProps> = ({
  current,
  total,
  className = '',
  showLabel = true,
}) => {
  const percentage = total > 0 ? Math.round((current / total) * 100) : 0;

  // Color based on progress
  const getColorClass = () => {
    if (percentage === 100) return 'bg-green-600';
    if (percentage >= 50) return 'bg-blue-600';
    return 'bg-amber-500';
  };

  return (
    <div className={`${className}`}>
      {showLabel && (
        <div className="flex justify-between items-center mb-1">
          <span className="text-xs font-medium text-gray-700">
            {current} of {total}
          </span>
          <span className="text-xs font-medium text-gray-700">{percentage}%</span>
        </div>
      )}
      <div className="w-full bg-gray-200 rounded-full h-2 overflow-hidden">
        <div
          className={`h-full rounded-full transition-all duration-300 ${getColorClass()}`}
          style={{ width: `${percentage}%` }}
          role="progressbar"
          aria-valuenow={percentage}
          aria-valuemin={0}
          aria-valuemax={100}
          aria-label={`Progress: ${percentage}%`}
        ></div>
      </div>
    </div>
  );
};
